module.exports = __webpack_public_path__ + "static/media/S (125).d707af3a.jpg";